/**
 * Store web sites list
 *
 * @param commit
 */

export function toggleColorize(_ref) {
  var commit = _ref.commit;
  commit('TOGGLE_COLORIZE');
}
export function toggleColorLegend(_ref2) {
  var commit = _ref2.commit;
  commit('TOGGLE_COLOR_LEGEND');
}